import { Motor } from './Motor';

export default Motor;
